import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <p className="font-mono-tech text-primary text-sm uppercase tracking-widest mb-2">Erreur 404</p>
        <h1 className="font-display text-5xl uppercase tracking-tight mb-4">Page introuvable</h1>
        <p className="text-muted-foreground mb-6">Cette rue de RiverSide n'existe pas.</p>
        <Button asChild><Link to="/">Retour à l'accueil</Link></Button>
      </div>
    </div>
  );
}
